import React from "react";
import AboutBierz from "./AboutBierz";

export default function About() {
  return <AboutBierz />;
}
